import script from "./icon-two-tones-task.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-task.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-task.vue?vue&type=style&index=0&id=036d8392&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036d8392"]])

export default __exports__